import { SuperTokensWrapper } from "supertokens-auth-react";
import { canHandleRoute, getRoutingComponent } from "supertokens-auth-react/ui";
import { ThirdPartyPreBuiltUI } from "supertokens-auth-react/recipe/thirdparty/prebuiltui";
import { EmailPasswordPreBuiltUI } from "supertokens-auth-react/recipe/emailpassword/prebuiltui";
import { EmailVerificationPreBuiltUI } from "supertokens-auth-react/recipe/emailverification/prebuiltui";
import { AuthRecipeComponentsOverrideContextProvider } from "supertokens-auth-react/ui";
import { useNavigate } from "react-router-dom";
import "@/config/supertokens";

export function ClientOnlySupertokens({
  children,
}: {
  children: React.ReactNode;
}) {
  const navigate = useNavigate();

  if (
    canHandleRoute([
      ThirdPartyPreBuiltUI,
      EmailPasswordPreBuiltUI,
      EmailVerificationPreBuiltUI,
    ])
  ) {
    const currentUrl = new URL(window.location.href);
    const isSignupPage = currentUrl.searchParams.get("show") === "signup";

    return (
      <AuthRecipeComponentsOverrideContextProvider
        components={{
          AuthPageHeader_Override: ({ DefaultComponent, ...props }) => {
            // If we're on the signup page, show the default component
            if (isSignupPage) {
              return <DefaultComponent {...props} />;
            }
            return (
              <div className="text-foreground">
                <h1>Sign In</h1>
                <div>
                  <span className="text-sm">Not registered yet? </span>
                  <a
                    href="/onboarding"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/onboarding");
                    }}
                  >
                    Sign Up
                  </a>
                </div>
              </div>
            );
          },
        }}
      >
        {getRoutingComponent([
          ThirdPartyPreBuiltUI,
          EmailPasswordPreBuiltUI,
          EmailVerificationPreBuiltUI,
        ])}
      </AuthRecipeComponentsOverrideContextProvider>
    );
  }
  return <SuperTokensWrapper>{children}</SuperTokensWrapper>;
}
